import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
            retry: 0,
            retryOnMount: false,
            staleTime: 1000 * 60 * 2, // 2 minutes
            // gcTime: 1000 * 60 * 2, // 2 minutes
        }
    }
});

export default queryClient;
